
export function dateFormat(month = 0) {
    let time = 'T23:59:59.330Z';

    const fechaActual = new Date();
    fechaActual.setMonth(fechaActual.getMonth() + month);

    const anno = fechaActual.getFullYear();
    let mes = (fechaActual.getMonth() + 1).toString().padStart(2, '0'); // Los meses comienzan desde 0
    let día = fechaActual.getDate().toString().padStart(2, '0');

    return `${anno}-${mes}-${día}${time}`;
}